import * as React from 'react';
import 'isomorphic-fetch';
export class ChangePassword extends React.Component {
    constructor() {
        super();
        this.state =
            {
                changeSuccessState: false,
                changeText: null,
                loadingState: false,
                currentPassword: "",
                newPassword: "",
                confirmNewPassword: ""
            };
    }
    render() {
        let contents = this.state.loadingState
            ? React.createElement("p", null,
                React.createElement("em", null, "Loading..."))
            : this.renderPage();
        return React.createElement("div", null, contents);
    }
    renderPage() {
        let statusText = React.createElement("div", null);
        let passwordForm = React.createElement("div", null);
        if (this.state.changeText != null) {
            statusText = React.createElement("div", null,
                React.createElement("br", null),
                "Status: ",
                this.state.changeText);
        }
        if (!this.state.changeSuccessState) {
            passwordForm = React.createElement("div", null,
                "Enter your current password",
                React.createElement("br", null),
                React.createElement("input", { className: "form-control", type: "password", onChange: (e) => { this.onCurrentPasswordChanged(e.target.value); }, value: this.state.currentPassword }),
                React.createElement("br", null),
                React.createElement("br", null),
                "New password",
                React.createElement("br", null),
                React.createElement("input", { className: "form-control", type: "password", onChange: (e) => { this.onNewPasswordChanged(e.target.value); }, value: this.state.newPassword }),
                React.createElement("br", null),
                "Confirm new password",
                React.createElement("br", null),
                React.createElement("input", { className: "form-control", type: "password", onChange: (e) => { this.onConfirmNewPasswordChanged(e.target.value); }, value: this.state.confirmNewPassword }),
                React.createElement("br", null),
                React.createElement("hr", null),
                React.createElement("button", { className: "btn btn-primary", onClick: () => this.onSaveChanges() }, "Save Changes"));
        }
        let result = React.createElement("div", null,
            passwordForm,
            statusText);
        return result;
    }
    onSaveChanges() {
        var passwordChangeData = new PasswordChangeData();
        passwordChangeData.currentPassword = this.state.currentPassword;
        passwordChangeData.newPassword = this.state.newPassword;
        passwordChangeData.confirmNewPassword = this.state.confirmNewPassword;
        var newState = {
            changeSuccessState: false,
            changeText: null,
            loadingState: true,
            currentPassword: this.state.currentPassword,
            newPassword: this.state.newPassword,
            confirmNewPassword: this.state.confirmNewPassword
        };
        this.setState(newState);
        fetch('Data/ChangePassword', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(passwordChangeData)
        })
            .then(response => response.json())
            .then(result => {
            if (result.successful) {
                this.setState({
                    changeSuccessState: true,
                    changeText: result.resultText,
                    loadingState: false,
                    currentPassword: "",
                    newPassword: "",
                    confirmNewPassword: ""
                });
            }
            else {
                this.setState({
                    changeSuccessState: false,
                    changeText: result.resultText,
                    loadingState: false,
                    currentPassword: this.state.currentPassword,
                    newPassword: this.state.newPassword,
                    confirmNewPassword: this.state.confirmNewPassword
                });
            }
        });
    }
    onCurrentPasswordChanged(password) {
        var newState = {
            changeSuccessState: this.state.changeSuccessState,
            changeText: this.state.changeText,
            loadingState: this.state.loadingState,
            currentPassword: password,
            newPassword: this.state.newPassword,
            confirmNewPassword: this.state.confirmNewPassword
        };
        this.setState(newState);
    }
    onNewPasswordChanged(password) {
        var newState = {
            changeSuccessState: this.state.changeSuccessState,
            changeText: this.state.changeText,
            loadingState: this.state.loadingState,
            currentPassword: this.state.currentPassword,
            newPassword: password,
            confirmNewPassword: this.state.confirmNewPassword
        };
        this.setState(newState);
    }
    onConfirmNewPasswordChanged(password) {
        var newState = {
            changeSuccessState: this.state.changeSuccessState,
            changeText: this.state.changeText,
            loadingState: this.state.loadingState,
            currentPassword: this.state.currentPassword,
            newPassword: this.state.newPassword,
            confirmNewPassword: password
        };
        this.setState(newState);
    }
}
class PasswordChangeData {
}
//# sourceMappingURL=ChangePassword.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/MyPage/ChangePassword.js
// module id = 95
// module chunks = 0